import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from "@mui/material";
import React from "react";

export const ConfirmNavigationDialog = (props: {
    open: boolean,
    handleConfirm: () => void,
    handleCancel: () => void,
    message: string
}) => {
    const {t} = useTranslation();

    return (
        <Dialog open={props.open} closeAfterTransition={false}>
            <DialogTitle>{t('confirmationDialog.warning')}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    {props.message}
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={props.handleCancel} color="primary">
                    {t('confirmationDialog.cancel')}
                </Button>
                <Button onClick={props.handleConfirm} color="primary" autoFocus>
                    {t('confirmationDialog.confirm')}
                </Button>
            </DialogActions>
        </Dialog>
    )
}